<div class="migration-success flex flex-column center gap-30">
  <img src="assets/images/svg/migration-fail-icon.svg" alt="" width="101" height="97" />
  <div class="title">
    {{ 'Uh oh!' | translate }}
  </div>
  <div class="sub-title" [innerHTML]="'We encountered a problem while migrating your account.' | translate"></div>
  <div class="err-container">
    <ng-container *ngFor="let key of errorKeys(error)">
      <div class="err-container__item item">
        <span class="item--key">{{ capitalize(key) }}:</span>
        <div *ngFor="let val of error[key]" class="item--val">- {{ val }}</div>
      </div>
    </ng-container>
  </div>
  <app-button [label]="'button.Try again' | translate" variant="secondary" (click)="onTryAgain()" />
  <div [innerHTML]="'or' | translate"></div>
  <div [innerHTML]="'Please contact us to resolve this issue.' | translate"></div>
  <app-button [label]="'button.Contact Us' | translate" variant="outlined" (click)="handleContactUs()" />
</div>
